//ajax caller
function dl_CallRestService(request, callback) {
    $.ajax({
        url: request,
        dataType: "jsonp",
        jsonp: "jsonp",
        success: function(r) {
            callback(r);
            dl_onApiSuccess && dl_onApiSuccess();
        },
        error: function(e) {
            geoDebug && console.log(e.statusText);
            dl_onApiError();
        }
    });
};

function dl_getLatLonFromQuery(query, callback) {
    geoDebug && console.log('query:', query);
    dl_CallRestService('https://dev.virtualearth.net/REST/v1/Locations?q=' + encodeURIComponent(query) + '&key=' + BingMapKey,

        function(res) {

            if (res.resourceSets["0"].estimatedTotal > 0) {
                //if any resource has entityType:postalcode1 then use that else use first 
                var resources = res.resourceSets["0"].resources;
                var resource;
                for (var i = 0; i < resources.length; i++) {

                    if (resources[i].entityType.indexOf('Postcode') >= 0) {
                        resource = resources[i];
                        break;
                    }
                }

                if (resource == null) {
                    resource = resources["0"];
                }

                callback(resource.geocodePoints["0"].coordinates["0"],
                    resource.geocodePoints["0"].coordinates["1"], resource.address.countryRegion);
                dl_onApiSuccess();
            } else {
                geoDebug && console.log('dl_getLatLonFromQuery: Not match found!');
                //callback();
                dl_onApiError();
            }
        })
}

function dl_getPinCode(lat, lon, callback) {

    dl_CallRestService('https://dev.virtualearth.net/REST/v1/Locations/' + lat + ',' + lon + '?key=' + BingMapKey,

        function(res) {
            //geoDebug && console.log('dl_getPinCode:', res);
            if (res.resourceSets["0"].estimatedTotal > 0 && res.resourceSets[0].resources[0].address.postalCode != null) {
                callback && callback(res.resourceSets[0].resources[0].address.postalCode, lat, lon, res.resourceSets[0].resources[0].address);
                dl_onApiSuccess();
            } else {
                geoDebug && console.log('dl_getPinCode: Not match found!');
                //callback(null, lat, lon);
                dl_onApiError();
            }
        })
}

function dl_getLatLon(zip, callback) {

    dl_CallRestService('https://dev.virtualearth.net/REST/v1/Locations?postalCode=' + zip + '&key=' + BingMapKey,

        function(res) {
            //geoDebug && console.log('dl_getLatLon:', res);
            if (res.resourceSets["0"].estimatedTotal > 0) {
                callback(res.resourceSets[0].resources[0].geocodePoints[0].coordinates[0],
                    res.resourceSets[0].resources[0].geocodePoints[0].coordinates[1], zip);
                dl_onApiSuccess();
            } else {
                geoDebug && console.log('dl_getLatLon: Not match found!');
                //callback();
                dl_onApiError();
            }
        })
}

var dl_onApiSuccess = function() {

}

var dl_onApiError = function() {

}

// get current user location from browser
var dl_getLocation = function() {

    // if browser supports HTML5 'navigator.geolocation'
    // Use HTML5 'navigator.geolocation' to get lat/long
    if (navigator.geolocation) {

        // get lat/long then call 'geolocator.setPositions()'
        // Only works in 'localhost' or 'https'

        navigator.geolocation.getCurrentPosition(

            //on success
            function(position) {

                // get zip from detected lat/lon
                dl_getPinCode(position.coords.latitude, position.coords.longitude, function(zip) {

                    //display the zip in textbox
                    ngScope().tZip.inputZip = zip || '';

                    if (!ngScope().$$phase) {
                        ngScope().$apply();
                    }

                    ngScope().global.zipOverlaySubmit();
                });

            }

            //on block/error
            ,
            function() {
                ngScope().global.showTabError(ngScope().tZip, 'Location couldn\'t be detected.');
            }

            , {
                timeout: 30000,
                enableHighAccuracy: true,
                maximumAge: 75000
            });
    }
}